<template>
    <div class="col-md-6 col-lg-4 mb-4">
        <div class="card proyecto-card h-100 shadow-sm">
            <div class="card-body d-flex flex-column">

                <!-- Título + ícono de copia -->
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <h5 class="mb-0">{{ proyecto.nombre }}</h5>
                    <font-awesome-icon icon="clipboard" class="copy-icon" @click="copiar(proyecto.nombre)"
                        title="Copiar nombre" />
                </div>

                <!-- Club -->
                <p class="text-muted d-flex align-items-center mb-3">
                    <font-awesome-icon :icon="['fas', 'users']" class="me-2" />
                    {{ proyecto.club?.nombre || 'Sin club' }}
                    <font-awesome-icon v-if="proyecto.club?.nombre" icon="clipboard" class="copy-icon ms-2"
                        @click="copiar(proyecto.club.nombre)" title="Copiar club" />
                </p>

                <!-- Plan -->
                <p class="d-flex align-items-center mb-2">
                    <font-awesome-icon :icon="['fas', 'clipboard-list']" class="me-2" />
                    <strong>Plan:</strong>&nbsp;{{ proyecto.plan_cultivo?.objetivo || 'Sin plan' }}
                    <font-awesome-icon v-if="proyecto.plan_cultivo?.objetivo" icon="clipboard" class="copy-icon ms-2"
                        @click="copiar(proyecto.plan_cultivo.objetivo)" title="Copiar plan" />
                </p>

                <!-- Lotes con scroll si hay muchos -->
                <div class="mb-2">
                    <div class="d-flex align-items-center mb-1">
                        <font-awesome-icon :icon="['fas', 'boxes']" class="me-2" />
                        <strong>Lotes:</strong>
                    </div>
                    <div v-if="proyecto.lotes?.length" class="scrollable-box">
                        <div v-for="lote in proyecto.lotes" :key="lote.id" class="item-line">
                            <span class="codigo">{{ lote.codigo }}</span>
                            <font-awesome-icon icon="clipboard" class="copy-icon ms-2" @click="copiar(lote.codigo)"
                                title="Copiar lote" />
                        </div>
                    </div>
                    <span v-else class="text-muted">Ninguno</span>
                </div>

                <!-- Biomasas con scroll -->
                <div class="mb-2">
                    <div class="d-flex align-items-center mb-1">
                        <font-awesome-icon :icon="['fas', 'leaf']" class="me-2" />
                        <strong>Biomasas:</strong>
                    </div>
                    <div v-if="proyecto.biomasa?.length" class="scrollable-box">
                        <div v-for="bio in proyecto.biomasa" :key="bio.id" class="item-line">
                            <span class="codigo">{{ bio.codigo }}</span>
                            <font-awesome-icon icon="clipboard" class="copy-icon ms-2" @click="copiar(bio.codigo)"
                                title="Copiar biomasa" />
                        </div>
                    </div>
                    <span v-else class="text-muted">Ninguna</span>
                </div>

                <!-- Fechas -->
                <p class="mb-3">
                    <font-awesome-icon :icon="['fas', 'calendar-alt']" class="me-2" />
                    <strong>Inicio:</strong> {{ proyecto.fecha_inicio }} <br />
                    <strong>Fin:</strong> {{ proyecto.fecha_fin || '—' }}
                </p>

                <!-- Resumen Económico completo -->
                <div class="mb-3">
                    <div class="d-flex align-items-center mb-2">
                        <font-awesome-icon :icon="['fas', 'chart-line']" class="me-2" />
                        <strong>Resumen:</strong>
                    </div>
                    <ul class="list-unstyled ms-3">
                        <li><strong>Costo total:</strong> ${{ proyecto.resumen?.totalCosto?.toFixed(2) || '0.00' }}</li>
                        <li><strong>Ganancia:</strong> ${{ proyecto.resumen?.totalGanancia?.toFixed(2) || '0.00' }}</li>
                        <li><strong>Horas trabajadas:</strong> {{ proyecto.resumen?.totalHoras?.toFixed(1) || '0' }} hs
                        </li>
                        <li><strong>Duración:</strong> {{ proyecto.resumen?.duracionDias || '—' }} días</li>
                        <li><strong>Margen:</strong> ${{ proyecto.resumen?.margen?.toFixed(2) || '0.00' }}</li>
                        <li><strong>% Ganancia:</strong> {{ proyecto.resumen?.porcentajeGanancia?.toFixed(1) || '0' }}%
                        </li>
                        <li><strong>Ganancia por hora:</strong> ${{ proyecto.resumen?.gananciaPorHora?.toFixed(2) ||
                            '0.00' }}</li>
                        <li><strong>% Ganancia por hora:</strong> {{
                            proyecto.resumen?.porcentajeGananciaPorHora?.toFixed(1) || '0' }}%</li>
                    </ul>
                </div>



                <!-- Botón de acción -->
                <button class="btn btn-primary w-100 mt-auto" @click="$emit('ver', proyecto)">
                    <font-awesome-icon :icon="['fas', 'eye']" class="me-2" /> Ver Proyecto
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

defineProps({ proyecto: Object })
defineEmits(['ver'])



function copiar(texto) {
    navigator.clipboard.writeText(texto)
        .then(() => console.log(`📋 Copiado: ${texto}`))
        .catch(err => console.error('Error al copiar:', err));
}
</script>

<style scoped>
.proyecto-card {
    border-left: 6px solid #198754;
    border-radius: 0.75rem;
    transition: box-shadow 0.3s ease;
    overflow: hidden;
}

.proyecto-card:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
}

.copy-icon {
    cursor: pointer;
    font-size: 0.85rem;
    color: #6c757d;
    transition: color 0.2s ease;
}

.copy-icon:hover {
    color: #198754;
}

.scrollable-box {
    max-height: 100px;
    overflow-y: auto;
    border: 1px solid #dee2e6;
    border-radius: 0.375rem;
    padding: 0.5rem;
    background-color: #f8f9fa;
}

.item-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2px 0;
    font-size: 0.9rem;
}

.codigo {
    font-family: monospace;
    background-color: #fff;
    padding: 2px 6px;
    border-radius: 4px;
}
</style>
